import { useDeactivateActivateTeamMemberMutation } from '../../../redux-toolkits/user/user.slice'
import { TeamMember } from '../../../redux-toolkits/user/user.type'
import { ConfirmationModal } from './confirmationModal'

export const ActivateTeamMemberModal = ({
  open,
  closeModal,
  teamMember,
  onSuccess,
}: {
  open: boolean
  closeModal: () => void
  teamMember: TeamMember
  onSuccess: () => void
}) => {
  const [deactivateActivateTeamMember, { isLoading }] =
    useDeactivateActivateTeamMemberMutation()

  return (
    <ConfirmationModal
      loading={isLoading}
      open={open}
      setOpen={() => {}}
      onCloseCallback={() => {
        closeModal()
      }}
      title={`${teamMember?.deleted ? 'Activate' : 'Deactivate'} team member`}
      message={`Are you sure you want to ${
        teamMember?.deleted ? 'activate' : 'deactivate'
      } ${teamMember.firstname} ${teamMember.lastname}?`}
      onConfirm={async () => {
        const resp = await deactivateActivateTeamMember({
          payload: {
            deleted: !teamMember.deleted,
          },
          id: teamMember?._id ?? '',
        })
        if (resp.data?.success) {
          onSuccess()
        }
      }}
      confirmText={teamMember?.deleted ? 'Activate' : 'Deactivate'}
    />
  )
}
